import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { last, lastValueFrom } from 'rxjs';

//services
import { CacheStorageService, LocalArticleService, OrderService } from '../shared/services';

//interfaces
import { ArticleInterface, ShopInterface } from '../shared/interfaces';
import { SetImagePipe } from '../shared/pipes/image.pipe';

@Component({
  selector: 'app-config',
  templateUrl: './config.component.html',
  styleUrl: './config.component.scss'
})
export class ConfigComponent implements AfterViewInit {
  public shops: ShopInterface[] = [];
  public selectedShop: string | null = null;
  public apiKey: string = '';
  public changed: boolean = false;
  public progress: number = 0;
  public imageLoading: boolean = false;

  articles: ArticleInterface[] = [];
  allArticles: ArticleInterface[] = [];

  fadeIn: boolean[] = [];

  displayedArticles: ArticleInterface[] = [];
  currentIndex = 0;


  constructor(
    private orderService: OrderService,
    private route: ActivatedRoute,
    private localArticleService: LocalArticleService,
    private setImage: SetImagePipe
  ) { }


  async ngAfterViewInit() {
    try {
      this.shops = await lastValueFrom(this.orderService.getShops())
      if (this.route.snapshot.queryParamMap.get('api_key') && this.route.snapshot.queryParamMap.get('shop')) {
        this.selectedShop = this.route.snapshot.queryParamMap.get('shop');
        this.apiKey = this.route.snapshot.queryParamMap.get('api_key')!;
        this.loadImages();
        return
      }
      const shop = localStorage.getItem('selectedShop');
      const api_key = localStorage.getItem('apiKey');
      if (shop) this.selectedShop = shop;
      if (api_key) this.apiKey = api_key;
    } catch (error) {

    }
  }

  public abort() {
    this.orderService.restart();
  }

  public async loadImages() {
    if (!this.selectedShop || !this.apiKey) return
    localStorage.setItem('selectedShop', this.selectedShop.toString())
    OrderService.shop.next(this.selectedShop);
    const idx = this.shops.findIndex((e) => e.id == Number(this.selectedShop));
    if (idx !== -1) {
      localStorage.setItem('selectedShopCode', this.shops[idx].code.toString())
      OrderService.shopCode.next(this.shops[idx].code.toString());
    }
    localStorage.setItem('apiKey', this.apiKey.toString())
    OrderService.kioskApiKey.next(this.apiKey.toString());
    this.imageLoading = true
    try {
      await CacheStorageService.deleteAll('articleImage');
      for (let i = 1; i < 5; i++) {
        let data = await lastValueFrom(this.orderService.getArticlesByCategory(i.toString()));
        if (data) {
          data.articleList = await this.setImage.transform(data.articleList);
          let readyImages = data.articleList.filter(element => String(element.image!).endsWith('.png'))
          this.articles.push(...readyImages);
        }
      }
      this.allArticles.push(...this.articles);
      this.displayedArticles = this.articles.splice(0, 10);

    } catch (error) {
      console.log(error)
    }
  }

  public async save() {
    this.orderService.loadingProgress.next(1);

    const sub = this.orderService.loadingProgress.subscribe(progress => {
      this.progress = progress;
      if (progress == 100) {
        this.articles.push(...this.allArticles);
        this.fadeIn = new Array(10).fill(true);
        this.displayedArticles = this.articles.splice(0, 10);
      }
    });

    const articles = await lastValueFrom(this.orderService.getArticles());
    sub.unsubscribe();
    if (articles)
      await this.localArticleService.addLocalArticles(articles.items);
    console.log(articles);
    this.orderService.restart();
  }

  onImageLoad(index: number) {
    this.fadeIn[index] = false;
    if (this.articles.length === 0) {
      if (this.progress == 100) {
        this.articles.push(...this.allArticles);
      } else {
        this.progress = 1;
        this.imageLoading = false;
        this.save();
        return;
      }
    }
    setTimeout(() => {
      this.displayedArticles[index] = this.articles.shift() || this.allArticles[0];
      this.fadeIn[index] = true;
    }, (this.progress == 100 ? 500 : 200));

  }
}
